<template>
  <div>
    <ContextMenu :options="reportOptions" />
    <ConfirmationDialog
      v-model:model-value="deleteDialog"
      title="Rapport verwijderen"
      message="Weet je zeker dat je dit rapport wilt verwijderen? Dit kan niet ongedaan worden gemaakt."
      @cancel="deleteDialog = false"
      @confirm="confirmDestroyReport"
    />
  </div>
</template>

<script>
import ContextMenu from "../ui/ContextMenu.vue";
import ConfirmationDialog from "../ui/ConfirmationDialog.vue";
import { useFormsStore } from "@/stores/formsStore";
import { useReportsStoreRefactor } from "@/stores/reportsStoreRefactor";

export default {
  name: "ReportContextMenu",
  components: { ContextMenu, ConfirmationDialog },
  props: ["report"],
  setup() {
    const formsStore = useFormsStore();
    const reportsStore = useReportsStoreRefactor();
    return { formsStore, reportsStore };
  },
  data() {
    return {
      deleteDialog: false,
    };
  },
  computed: {
    reportOptions() {
      return [
        {
          name: "Rapport wijzigen",
          action: this.editReport,
          icon: "mdi-playlist-edit",
          show: this.report.edit,
        },
        {
          name: "Rapport verwijderen",
          action: this.destroyReport,
          icon: "mdi-playlist-remove",
          show: this.report.destroy,
        },
      ];
    },
  },
  methods: {
    editReport() {
      this.formsStore.edit({ type: "report", item: this.report });
    },
    destroyReport() {
      this.deleteDialog = true;
    },
    async confirmDestroyReport() {
      try {
        await this.reportsStore.destroy(this.report);
      } catch (e) {
        // errors handled in store
      } finally {
        this.deleteDialog = false;
      }
    },
  },
};
</script>
